import type { ProfileData } from "@recursive-robot/react-jsx-parser";
import {
    PROFILING_SET_ENABLED,
    PROFILING_SET_REACT_RENDER_ENABLED,
    PROFILING_BATCH_RECEIVED,
    PROFILING_SELECT_CYCLE,
    PROFILING_CLEAR,
    SetProfilingEnabledAction,
    SetReactRenderEnabledAction,
    ProfilingBatchReceivedAction,
    SelectCycleAction,
    ClearProfilingAction,
} from "./types";
import { setTracingEnabled } from "../tracing/actions";
import { setProfilingBuildCookie } from "../../shared/profiling-build";

export function profilingBatchReceived(batch: ProfileData) {
    return (dispatch) => {
        dispatch({ type: PROFILING_BATCH_RECEIVED, batch } as ProfilingBatchReceivedAction);
    };
}

export function setProfilingEnabled(enabled: boolean) {
    return (dispatch) => {
        dispatch({ type: PROFILING_SET_ENABLED, enabled } as SetProfilingEnabledAction);
        // Profiling and tracing are coupled: enabling/disabling profiling drives tracing in both
        // directions (the Event Log tab's own toggle still enables tracing standalone).
        dispatch(setTracingEnabled(enabled));
    };
}

export function setReactRenderEnabled(enabled: boolean) {
    return (dispatch) => {
        dispatch({ type: PROFILING_SET_REACT_RENDER_ENABLED, enabled } as SetReactRenderEnabledAction);
        // The middleware serves the React profiling build (profiling.html) while this cookie is
        // set — effective from the next full page load...
        setProfilingBuildCookie(enabled);
    };
}

export function selectCycle(cycleId: string | null) {
    return (dispatch) => {
        dispatch({ type: PROFILING_SELECT_CYCLE, cycleId } as SelectCycleAction);
    };
}

export function clearProfiling() {
    return (dispatch) => {
        dispatch({ type: PROFILING_CLEAR } as ClearProfilingAction);
    };
}
